import { ChatIcon, EmailIcon } from "@chakra-ui/icons";
import { Box, Flex, HStack, Text, VStack } from "@chakra-ui/react";
import dayjs from "dayjs";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import Breadcrumbs from "../../components/Shared/Breadcrumbs/Breadcrumbs";
import LoadingIndicator from "../../components/Shared/LoadingIndicator/LoadingIndicator";
import { NotificationLogsBreadcrumbs } from "../../configs/breadcrumbNavigation";
import { useNotificationLog } from "../../networking/dev-log.hooks";

const NotificationLogsPage: React.FC = () => {
	const { t } = useTranslation();
	const [expandedRow, setExpandedRow] = useState("");

	const { data, isLoading } = useNotificationLog({});

	function handleExpandRow(id: string) {
		if (expandedRow === id) {
			setExpandedRow("");
			return;
		}
		setExpandedRow(id);
	}

	function renderTo(notifType: string, to: string | string[]) {
		if (Array.isArray(to)) {
			return to.map((item) => (
				<Text data-contact={notifType === "notification" ? item : ""}>{item}</Text>
			));
		}
		return <Text data-contact={notifType === "notification" ? to : ""}>to</Text>;
	}

	return (
		<div className="p-4 px-6">
			<Breadcrumbs items={NotificationLogsBreadcrumbs} />
			<Flex>
				{isLoading ? (
					<LoadingIndicator />
				) : (
					<VStack w="full" bg="white" spacing={"0"}>
						{data?.map((item) => (
							<Box
								key={item.transactionId}
								borderBottomStyle="solid"
								borderBottomColor={"gray.100"}
								w="full"
								px="2"
								py="3"
								_hover={{ bg: "gray.50" }}
								cursor={"pointer"}
								onClick={() => handleExpandRow(item.transactionId)}
							>
								<HStack userSelect={"none"}>
									<Box w="10">{item.type === "mail" ? <EmailIcon /> : <ChatIcon />}</Box>

									<Box w="400px">{renderTo(item.type, item.to)}</Box>

									<Text w="400px" noOfLines={1} textOverflow={"ellipsis"}>
										{item.type === "mail" ? item.mail?.subject : item.notification?.body}
									</Text>
									<Text flex={1} w="200px" textAlign={"right"} fontSize={"sm"} color="gray.500">
										{dayjs(item.created).format("YYYY-MM-DD HH:mm")}
									</Text>
								</HStack>
								{expandedRow === item.transactionId && (
									<Box maxW="600px" bg="white" p="3" m="4">
										<Text fontWeight={"medium"}>
											{item.type === "mail"
												? "Ämne: " + item.mail?.subject
												: item.notification?.title}
										</Text>

										{item.type === "mail" && (
											<MailTemplateStyles
												dangerouslySetInnerHTML={{ __html: item.mail?.body || "n/a" }}
											/>
										)}
										{item.type === "notification" && <Text>{item.notification?.body}</Text>}
									</Box>
								)}
							</Box>
						))}
					</VStack>
				)}
			</Flex>
		</div>
	);
};

export default NotificationLogsPage;

const MailTemplateStyles = styled.div`
	p {
		margin: 0 0 1rem 0;
	}

	li,
	ul,
	ol {
		list-style-position: inside;
	}

	a {
		text-decoration: underline;
	}
`;
